export const timezone = Math.abs(new Date().getTimezoneOffset() / 60);
